import img from './sensations.mp4';
import text from './text';

export const story = {
    slug: 'sensations',
    title: 'Sensations',
    interactive: 'sensations',
    img: img,
    year: 'Feelings and believings',
    tags: ['horror', 'sci-fi'],
    md: text,
}